import { useEffect, useRef } from 'react'

/**
 * Hook to check if component is mounted
 *
 * Returns React.Ref object with possible `current` values:
 *  `undefined` - Component is mounting
 *  `true` - Component is mounted
 *  `false` - Component was unmounted
 */
export function useIsMountedRef() {
  const isMountedRef = useRef()

  useEffect(() => {
    isMountedRef.current = true

    return () => {
      isMountedRef.current = false
    }
  }, [])

  return isMountedRef
}
